import React from "react"
import "./cardDetail.less"
import { Col, Empty, Popover, Row, Space, Typography, Tooltip, Button } from "antd"

function CardDetail(props) {
  const { data, onClick, style, mobile = false } = props
  console.log(data)
  return (
    <Row gutter={[16, 16]} className='cardDetail' style={style}>
      {data?.length ? (
        data?.map((item, index) => {
          return mobile ? (
            <div className='m-znt-space' key={index} style={{ cursor: "pointer" }}>
              <div
                className='listItem'
                key={index}
                onClick={() => {
                  onClick?.(item)
                }}
              >
                {item.outerznt ? <div className="agent-tags">
                  <Button size="small" shape="round" color="primary" variant="filled">外部智能体</Button>
                </div> : null}
                <div className='iconContent'>
                  <div className='icon'>
                    <img src={item?.icon} />
                  </div>
                  <div className='wrapContent'>
                    <div className='titleAndContent'>
                      <div className='cardTitle'>{item.label}</div>
                      <Tooltip content={item?.summary ?? ""}>
                        <Typography.Paragraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            color: "rgb(51, 51, 51)",
                            fontSize: 13,
                            opacity: 0.6,
                            fontWeight: 400,
                            fontFamily: "思源黑体 CN",
                          }}
                        >
                          {item?.summary ?? ""}
                        </Typography.Paragraph>
                      </Tooltip>
                    </div>
                    <div className='agreeAndCollect'>
                      <div className='icons'>
                        {/* <div>
                    <HeartOutlined />
                    <span>2356</span>
                  </div>
                  <div>
                    <StarOutlined />
                    <span>165</span>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Col className='znt-col' xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} key={index} style={{ cursor: "pointer" }}>
              <div
                className='listItem'
                key={index}
                onClick={() => {
                  onClick?.(item)
                }}
              >
                {item.outerznt ? <div className="agent-tags">
                  <Button size="small" shape="round" color="primary" variant="filled">外部智能体</Button>
                </div> : null}
                <div className='iconContent'>
                  <div className='icon'>
                    <img src={item?.icon} />
                  </div>
                  <div className='wrapContent'>
                    <div className='titleAndContent'>
                      <div className='cardTitle'>{item.label}</div>
                      <Tooltip content={item?.summary ?? ""}>
                        <Typography.Paragraph
                          ellipsis={{ rows: 3 }}
                          style={{
                            color: "rgb(51, 51, 51)",
                            fontSize: 13,
                            opacity: 0.6,
                            fontWeight: 400,
                            fontFamily: "思源黑体 CN",
                          }}
                        >
                          {item?.summary ?? ""}
                        </Typography.Paragraph>
                      </Tooltip>
                    </div>
                    <div className='agreeAndCollect'>
                      <div className='icons'>
                        {/* <div>
                          <HeartOutlined />
                          <span>2356</span>
                        </div>
                        <div>
                          <StarOutlined />
                          <span>165</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )
        })
      ) : (
        <Col span={24}>
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <Typography.Text style={{ textAlign: "center" }} type='secondary'>
              <Empty style={{ height: 50 }} description={"暂无数据"}></Empty>
            </Typography.Text>
          </div>
        </Col>
      )}
      <div></div>
    </Row>
  )
}

export default CardDetail
